<!-- ============ BANNER CONSENSO (in basso) ============ -->
@if (bannerVisible && !prefsVisible) {
	<div class="cookie-banner" role="dialog" aria-label="Informativa cookie">
		<div class="cookie-banner__body">
			<h6 class="cookie-banner__title">
				<i class="pi pi-shield" aria-hidden="true"></i> Rispettiamo la tua privacy
			</h6>
			<p class="cookie-banner__text">
				Utilizziamo cookie tecnici (necessari) e, previo tuo consenso, cookie analitici e di profilazione, anche di terze parti, per
				migliorare la tua esperienza sul portale. Cliccando su <strong>“Accetta”</strong> acconsenti all'utilizzo di tutti i cookie.
				Puoi scegliere le finalità cliccando su <strong>“Personalizza”</strong>.
			</p>
		</div>
		<div class="cookie-banner__actions">
			<p-button label="Rifiuta" size="small" severity="secondary" [outlined]="true" (onClick)="rejectAll()"></p-button>
			<p-button label="Personalizza" size="small" severity="secondary" [outlined]="true" icon="pi pi-sliders-h" (onClick)="openPreferences()"></p-button>
			<p-button label="Accetta" size="small" severity="primary" icon="pi pi-check" (onClick)="acceptAll()"></p-button>
		</div>
	</div>
}

<!-- ============ MODAL "PERSONALIZZA" ============ -->
<p-dialog
	header="Impostazioni cookie"
	[(visible)]="prefsVisible"
	[modal]="true"
	[draggable]="false"
	[resizable]="false"
	[dismissableMask]="false"
	[style]="{ width: '46rem' }"
	[breakpoints]="{ '960px': '95vw' }"
	styleClass="cookie-dialog">

	<h6>Cosa sono i cookie</h6>
	<p class="cookie-text">
		I cookie sono piccoli file di testo che i siti web visitati dall'utente inviano al terminale dell'utente, dove vengono memorizzati,
		per poi essere ritrasmessi agli stessi siti web alla visita successiva.
	</p>
	<p class="cookie-text">
		Questo sito utilizza cookie tecnici (o necessari), cookie analitici e cookie di profilazione, sia propri che di terze parti.
		I cookie tecnici garantiscono la normale navigazione e non richiedono il preventivo consenso dell'utente; per le altre categorie
		puoi selezionare qui sotto le finalità per cui acconsenti all'utilizzo dei tuoi dati personali.
	</p>

	<p-divider />

	<!-- NECESSARI -->
	<div class="cookie-cat">
		<div class="cookie-cat__head">
			<div>
				<span class="cookie-cat__name">Necessari</span>
				<span class="cookie-cat__badge">Sempre attivi</span>
			</div>
			<p-toggleswitch [ngModel]="true" [disabled]="true" [ariaLabel]="'Cookie necessari sempre attivi'"></p-toggleswitch>
		</div>
		<p class="cookie-cat__desc">
			Garantiscono le funzionalità di base e la sicurezza del sito. Senza questi cookie il portale non può funzionare correttamente.
		</p>
		<div class="cookie-table-wrap">
			<table class="cookie-table">
				<thead>
					<tr><th>Cookie</th><th>Durata</th><th>Descrizione</th></tr>
				</thead>
				<tbody>
					<tr>
						<td>kcs-cookie-consent</td>
						<td>1 anno</td>
						<td>Cookie di tipo "First-party" che memorizza le preferenze espresse tramite questo banner.</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>

	<!-- FUNZIONALI -->
	<div class="cookie-cat">
		<div class="cookie-cat__head">
			<span class="cookie-cat__name">Funzionali</span>
			<p-toggleswitch [(ngModel)]="prefs.functional" [ariaLabel]="'Cookie funzionali'"></p-toggleswitch>
		</div>
		<p class="cookie-cat__desc">
			Consentono di ricordare le scelte effettuate (ad es. lingua o preferenze di visualizzazione) per offrire funzionalità
			personalizzate.
		</p>
	</div>

	<!-- ANALITICI -->
	<div class="cookie-cat">
		<div class="cookie-cat__head">
			<span class="cookie-cat__name">Analitici</span>
			<p-toggleswitch [(ngModel)]="prefs.analytics" [ariaLabel]="'Cookie analitici'"></p-toggleswitch>
		</div>
		<p class="cookie-cat__desc">
			Raccolgono informazioni statistiche in forma aggregata su come gli utenti utilizzano il sito, con meccanismi
			(come l'anonimizzazione dell'indirizzo IP) che impediscono l'identificazione diretta dell'utente.
		</p>
	</div>

	<!-- PRESTAZIONI -->
	<div class="cookie-cat">
		<div class="cookie-cat__head">
			<span class="cookie-cat__name">Prestazioni</span>
			<p-toggleswitch [(ngModel)]="prefs.performance" [ariaLabel]="'Cookie di prestazione'"></p-toggleswitch>
		</div>
		<p class="cookie-cat__desc">
			Aiutano a comprendere gli indici di rendimento del sito, contribuendo a offrire una migliore esperienza di navigazione.
		</p>
	</div>

	<!-- ANNUNCI -->
	<div class="cookie-cat">
		<div class="cookie-cat__head">
			<span class="cookie-cat__name">Annunci</span>
			<p-toggleswitch [(ngModel)]="prefs.ads" [ariaLabel]="'Cookie di profilazione e annunci'"></p-toggleswitch>
		</div>
		<p class="cookie-cat__desc">
			Cookie di profilazione utilizzati per raccogliere informazioni sulle preferenze dell'utente e rendere gli annunci pubblicitari
			forniti da terze parti più pertinenti.
		</p>
	</div>

	<ng-template #footer>
		<div class="d-flex justify-content-end gap-2 flex-wrap">
			<p-button label="Rifiuta tutti" size="small" severity="secondary" [outlined]="true" (onClick)="rejectAll()"></p-button>
			<p-button label="Salva preferenze" size="small" severity="secondary" [outlined]="true" icon="pi pi-save" (onClick)="savePreferences()"></p-button>
			<p-button label="Accetta tutti" size="small" severity="primary" icon="pi pi-check" (onClick)="acceptAll()"></p-button>
		</div>
	</ng-template>
</p-dialog>
